<svg class="icon" [attr.height]="height" [attr.width]="width">
  <use [attr.xlink:href]="href"></use>
</svg>
